import { parseResponse } from  '../../../helpers/api'
import client from '../../../client'
import _ from 'lodash';

export default {
    async get (id) {
        return client.v2.get(`/patients/get`, {
            params: {
                id: id,
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getPatients (skip, limit, filters, sortBy, order) {
        let response = null

        try {
            response = await client.v2.get(`/patients/get-list`, {
                params: {
                    skip: skip,
                    limit: limit,
                    sortBy: sortBy,
                    order: order,
                    filters: filters
                }
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async create (patientData) {
        let response = null
        try {
            response = await client.v2.post(`/patients/create`, {
                name: _.get(patientData, 'name'),
                gender: _.get(patientData, 'gender'),
                birthday: _.get(patientData, 'birthday'),
                address: _.get(patientData, 'address'),
                phone: _.get(patientData, 'phone'),
                email: _.get(patientData, 'email'),
                comment: _.get(patientData, 'comment')
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async update (patientData) {
        let response = null
        try {
            response = await client.v2.post(`/patients/update`, {
                id: _.get(patientData, 'id'),
                name: _.get(patientData, 'name'),
                gender: _.get(patientData, 'gender'),
                birthday: _.get(patientData, 'birthday'),
                address: _.get(patientData, 'address'),
                phone: _.get(patientData, 'phone'),
                email: _.get(patientData, 'email'),
                comment: _.get(patientData, 'comment')
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async delete(patientId) {
        let response = null
        try {
            response = await client.v2.post(`/patients/delete`, {
                id: patientId
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async getByName (name, limit) {
        return client.v1.get(`/patients/get-by-name`, {
            params: {
                name: name,
                limit: limit
            }
        }).then((response) => {
            return parseResponse(response)
        })
    }
}